import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';

import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/home/Home';
import Login from './pages/login/Login';


import { ProtectedRoute } from './components/ProtectedRoute';
import Register from './pages/register/Register';
import Dashboard from './pages/dashboard/Dashboard';
import Articles from './pages/article/Articles';
import './index.css';
import Brands from './pages/brand/Brands';
import NewBrand from './pages/brand/NewBrand';
import NewArticle from './pages/article/NewArticle';
import Users from './pages/user/Users';
import Orders from './pages/orders/Orders';
import Categories from './pages/category';
import NewCategory from './pages/category/new';
import Stores from './pages/store';
import LayoutContext from './context/layoutContext';
import EditUser from './pages/user/new';
import NewUser from './pages/user/new';
import NewStore from './pages/store/new';
import ViewOrder from './pages/orders/view';
import ViewCart from './pages/cart/view';
import Unauthorized from './pages/unauthorized';
import ApiService from './services/ApiService';
import { UserContext } from './context/userContext';
import NotFound from './pages/unauthorized/404';
import UserProfile from './pages/user/profile';
import Article from './pages/article/article';
import Promotions from './pages/promotions/Promotions';
import NewPromotion from './pages/promotions/new';
import ViewPromotion from './pages/promotions/view';
import Tools from './pages/tools/Tools';


function App() {


  const { user } = useContext(UserContext)

  useEffect(() => {
    console.log("APP", user)
  }, [])

  return (




    <Routes>
      {/* <Route path='/' element={<NotFound />} /> */}
      <Route path='/login' element={<Login />} />
      <Route path='/register' element={<Register />} />
      <Route path='/unauthorized' element={<Unauthorized />} />

      <Route element={<ProtectedRoute allowedRoles={['Manager', 'Admin', 'User']} userRole={user?.details?.roleName} />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/cart" element={<ViewCart />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/orders/view" element={<ViewOrder />} />
        <Route path="/promotion" element={<ViewPromotion />} />
      </Route>

    
      <Route element={<ProtectedRoute allowedRoles={['Manager', 'Admin']} userRole={user?.details?.roleName} />}>
        <Route path="/article" element={<Article />} />
      </Route>

      <Route element={<ProtectedRoute allowedRoles={['Admin']} userRole={user?.details?.roleName} />}>
        <Route path="/promotions" element={<Promotions />} />
        <Route path="/promotions/new" element={<NewPromotion />} />
    
        <Route path="/tools" element={<Tools />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/stores" element={<Stores />} />
        <Route path="/users" element={<Users />} />
        <Route path="/brands/new" element={<NewBrand />} />
        <Route path="/categories/new" element={<NewCategory />} />
        <Route path="/stores/new" element={<NewStore />} />
        <Route path="/users/new" element={<NewUser />} />
        <Route path="/articles/new" element={<NewArticle />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" />} />
      {/* <Route path="*" element={<NotFound />} /> */}


    </Routes>


  );
}


export default App;
